import type { RouteRecordRaw } from 'vue-router';

export const reportsRoutes: RouteRecordRaw[] = [
  {
    path: 'reports',
    name: 'reports',
    component: () => import('./pages/ReportsPage.vue'),
    meta: { title: 'Reports', requiresAuth: true, permission: 'is-admin' },
  },
  {
    path: 'reports/statements',
    name: 'reports.statements',
    component: () => import('./pages/FinancialStatementsPage.vue'),
    meta: { title: 'Financial statements', requiresAuth: true },
  },
  {
    path: 'reports/atk-register',
    name: 'reports.atk-register',
    component: () => import('./pages/AtkRegisterPage.vue'),
    meta: { title: 'ATK filing register', requiresAuth: true },
  },
];
